import { getJobcloudDomain } from '@mkp/shared/util-environment';

const passwordlessLoginUtmParams = (lg: string) => ({
  utm_source: 'automail-user',
  utm_medium: 'email',
  utm_campaign: `wb:${getJobcloudDomain()}|tg:b2b|cn:ch|lg:${lg}|email-verification-passwordless-login-link`,
});

export function generatePasswordlessLoginRedirectUri(
  baseRedirectUri: string,
  language: string
): string {
  const params = passwordlessLoginUtmParams(language);
  const searchParams = new URLSearchParams(params);
  return `${baseRedirectUri}?${searchParams.toString()}`;
}
